@if (data.title) {
<h1 mat-dialog-title>{{ data.title }}</h1>
}

<mat-dialog-content>
  <p [innerHTML]="data.message | safeHtml"></p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="undefined" [disabled]="submitted()">
    {{ data.cancelText }}
  </button>

  <button mat-button (click)="handleConfirm()" [disabled]="submitted()" cdkFocusInitial>
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">{{
      data.confirmText
    }}</span>
  </button>
</mat-dialog-actions>
